// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__4iuZs","buttons":"PendingPaymentAlert_buttons__17l91"};